import { directTreasuryOrderResumeData } from './types';

interface DirectTreasuryTableTemplateProps {
  data: directTreasuryOrderResumeData[];
  assetCount: number;
  totalValue: string;
}

export const directTreasuryTableTemplate = ({
  assetCount,
  data,
  totalValue,
}: DirectTreasuryTableTemplateProps) => {
  if (assetCount === 0) {
    return '';
  }

  return `
      <div class="product-card">
        <strong class="product-type-title">TESOURO DIRETO</strong>
        <div class="product-info">
           <span class="product-info-text">${assetCount} Ativo(s)</span>
          <span class="product-info-text">Total ${totalValue}</span>
        </div>
      </div>
      <div class="product-table">
        <div class="highlight-bar direct-treasury"></div>
        <div class="product-table-content">
          <table>
            <thead>
              <tr>
                <th style="width: 80px;">ativo</th>
                <th style="width: 30px;">aplicação</th>
                <th style="width: 30px;">liquidação</th>
                <th style="width: 30px;">vencimento</th>
                <th style="width: 30px;">quantidade</th>
                <th style="width: 30px;">valor</th>
              </tr>
            </thead>
            <tbody>
            ${data.map((item) => {
              return `<tr>
              <td>${item.productDisplay}</td>
              <td>${item.applicationDate}</td>
              <td>${item.liquidityDate}</td>
              <td>${item.maturityDate}</td>
              <td>${item.quantity}</td>
              <td>${item.valueAppliedFormatted}</td>
            </tr>`;
            })}
            </tbody>
          </table>
        </div>
      </div>
      `;
};
